import React from "react";
import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { verifyUser } from "../helpers/apiCalls";

const UserVerification = () => {
  let { emailVerifToken } = useParams();
  const [verifMsg, setVerifMsg] = useState("");

  useEffect(() => {
    const sendVerifToken = async () => {
      const response = await verifyUser(emailVerifToken);

      if (response.error) {
        setVerifMsg(response.error.message);
      } else setVerifMsg(response.message);
    };

    sendVerifToken();
  }, [emailVerifToken]);

  return (
    <div className="email-verif">
      <section>
        <p>{verifMsg}</p>
        <Link to="/dashboard">
          <button type="submit">Next</button>
        </Link>
      </section>
    </div>
  );
};

export default UserVerification;
